// Import model
import { OtgUserCondition } from '../models/OtgUserCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { OtgUserIndexedFields } from '../models/OtgUserIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { OtgUserIndexedFieldsSerializer } from './OtgUserIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgUserCondition - handles JSON serialization and deserialization with type validation
 */
export class OtgUserConditionSerializer {
  /**
   * Deserializes a JSON string into a OtgUserCondition instance
   */
  static deserialize(json: string): OtgUserCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgUserCondition instance
   */
  static fromObject(obj: any): OtgUserCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgUserCondition');
    }


    const instance: OtgUserCondition = {
      fieldName: obj['fieldName'] as OtgUserIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgUserCondition instances
   */
  static deserializeArray(json: string): OtgUserCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgUserCondition instance to a JSON string
   */
  static serialize(instance: OtgUserCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgUserCondition instance to a plain object
   */
  static toObject(instance: OtgUserCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of OtgUserCondition instances to a JSON string
   */
  static serializeArray(instances: OtgUserCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
